/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 納品（受入）可能フラグ（土曜日）
 * @export
 * @interface EnableArrivalSat
 */
export interface EnableArrivalSat {
}

/**
 * Check if a given object implements the EnableArrivalSat interface.
 */
export function instanceOfEnableArrivalSat(value: object): value is EnableArrivalSat {
    return true;
}

export function EnableArrivalSatFromJSON(json: any): EnableArrivalSat {
    return EnableArrivalSatFromJSONTyped(json, false);
}

export function EnableArrivalSatFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnableArrivalSat {
    return json;
}

export function EnableArrivalSatToJSON(json: any): EnableArrivalSat {
    return EnableArrivalSatToJSONTyped(json, false);
}

export function EnableArrivalSatToJSONTyped(value?: EnableArrivalSat | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

